/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable camelcase */
import { useEffect, useRef } from "react";
import { useCookies } from "./useCookies";
import { useLocalStorage } from "./useLocalStorage";
import { deleteCookies, getCookie } from "../utils/cookiesHelper";
import { dateHelper } from "../utils/dateHelper";

export const CODE_KEY = "code";
export const ACCESS_TOKEN = "KC_ACCESS_TOKEN";
export const REFRESH_TOKEN = "KC_REFRESH_TOKEN";
export const ACCESS_TOKEN_EXP_IN = "ACCESS_TOKEN_EXP_IN";
export const REFRESH_TOKEN_EXP_IN = "REFRESH_TOKEN_EXP_IN";
export const QUERY_PARAM_LOGIN = "QUERY_PARAM_LOGIN";

export const useAuth = (options = {}) => {
  const {
    onLoginRedirect,
    onTokenRefresh,
    onLogout,
    onError,
    apiService // Optional API service injection
  } = options;

  const hasCleanedUp = useRef(false);
  const [authToken, setAuthToken] = useCookies(ACCESS_TOKEN, null);
  const [refreshToken, setRefreshToken] = useCookies(REFRESH_TOKEN, null);
  const [queryParamLogin, setQueryParamLogin] = useCookies(
    QUERY_PARAM_LOGIN,
    false
  );
  const [sessionTokenExpiresIn, setSessionTokenExpiresIn] =
    useCookies(REFRESH_TOKEN_EXP_IN);
  const [href, setHref] = useLocalStorage(window.location.origin, "/");

  const fetchTokensFromURL = () => {
    if (typeof window === "undefined") return false;
    
    const urlParams = new URLSearchParams(window.location.search);
    const accessTokenFromUrl = urlParams.get("accessToken");
    const refreshTokenFromUrl = urlParams.get("refreshToken");
    
    if (accessTokenFromUrl && refreshTokenFromUrl && !hasCleanedUp.current) {
      setAuthToken(accessTokenFromUrl);
      setRefreshToken(refreshTokenFromUrl);
      setQueryParamLogin(true);
      const now = new Date();
      const refreshExpIn = dateHelper.addSeconds(now, 1800);
      setSessionTokenExpiresIn(refreshExpIn);

      setTimeout(() => {
        window.history.replaceState({}, document.title, window.location.pathname);
        hasCleanedUp.current = true;
      }, 0);
      return {
        authToken: accessTokenFromUrl
      };
    }
    return false;
  };

  useEffect(() => {
    fetchTokensFromURL();
  }, []);

  useEffect(() => {
    if (href === "undefined") {
      setHref("/");
    }
  }, [href]);

  const refreshAccessToken = async () => {
    try {
      const queryParamLoginFlag =
        queryParamLogin === true ||
        queryParamLogin === "true" ||
        getCookie(QUERY_PARAM_LOGIN) === "true";
      const refreshTokenToBeUsed = queryParamLogin
        ? getCookie(REFRESH_TOKEN)
        : refreshToken;
      
      if (!refreshTokenToBeUsed) {
        console.warn(
          `An invalid Refresh token with ${refreshTokenToBeUsed} cannot be used to make an api call to refresh authToken`
        );
        return;
      }

      if (onTokenRefresh) {
        const tokenData = await onTokenRefresh({
          refreshToken: refreshTokenToBeUsed,
          queryParamLogin: queryParamLoginFlag
        });
        
        if (tokenData) {
          storeAuthAndRefreshToken(tokenData);
        }
      } else {
        console.warn("No token refresh handler provided");
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
      if (onError) {
        onError(error);
      }
    }
  };

  const storeAuthAndRefreshToken = (tokenData) => {
    if (!tokenData) return;
    
    const { access_token, refresh_token, expires_in, refresh_expires_in } =
      tokenData?.data?.data?.data || tokenData?.data?.data || tokenData;
    
    console.log("access_token:", access_token);
    setAuthToken(access_token);
    setRefreshToken(refresh_token);
    const accessTokenExpiresIn = dateHelper.addSeconds(new Date(), expires_in);
    const refreshTokenExpiresIn = dateHelper.addSeconds(
      new Date(),
      refresh_expires_in
    );
    setSessionTokenExpiresIn(refreshTokenExpiresIn);
  };

  const destroySession = () => {
    try {
      const refreshTokenToBeUsed = queryParamLogin
        ? getCookie(REFRESH_TOKEN)
        : refreshToken;
      
      if (onLogout) {
        onLogout({ refreshToken: refreshTokenToBeUsed });
      }
      
      deleteCookies();
      if (typeof window !== "undefined") {
        window.location.replace(window.location.origin);
      }
    } catch (error) {
      console.error("Error destroying session:", error);
      if (onError) {
        onError(error);
      }
    }
  };

  const login = (redirectUrl) => {
    if (typeof window !== "undefined") {
      setHref(`${window.location.pathname}${window.location.search}`);
      if (onLoginRedirect) {
        onLoginRedirect(redirectUrl || `${window.location.origin}/loginCallback`);
      }
    }
  };

  useEffect(() => {
    if (sessionTokenExpiresIn && new Date(sessionTokenExpiresIn) < new Date()) {
      destroySession();
    }
  }, [sessionTokenExpiresIn]);

  return {
    isLoggedIn: !!authToken,
    destroySession,
    authToken,
    refreshAccessToken,
    login,
    storeAuthAndRefreshToken
  };
};
